import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStatistic = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.75476 4.73129C10.7054 4.61708 11.5409 5.364 11.5409 6.31754V12.3673C11.5409 12.4197 11.5822 12.4599 11.6325 12.4599H17.6833C18.6368 12.4599 19.3838 13.2955 19.2696 14.2461C18.6914 19.0168 14.1804 22.5741 9.08526 21.5838C5.74748 20.9358 3.06496 18.2532 2.41605 14.9156C1.42687 9.82064 4.98409 5.30949 9.75476 4.73129ZM3.88848 14.6293C3.07009 10.4134 6.00284 6.69731 9.93391 6.22056L3.88848 14.6293ZM9.93391 6.22056C9.95974 6.21751 9.98496 6.22485 10.0074 6.24478C10.03 6.26486 10.0409 6.29003 10.0409 6.31754V12.3673C10.0409 13.247 10.7527 13.9599 11.6325 13.9599H17.6833C17.7108 13.9599 17.736 13.9709 17.7561 13.9934C17.7761 14.0159 17.7834 14.0412 17.7803 14.0671C17.3038 17.9986 13.5875 20.9308 9.37144 20.1113C6.63426 19.58 4.42079 17.3667 3.88848 14.6293",
		fill: "#D9AA04"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.0352 3.84798C13.0352 2.88812 13.8831 2.13846 14.839 2.2637C18.4263 2.73507 21.266 5.5745 21.7374 9.16183C21.8625 10.1184 21.1141 10.9659 20.1531 10.9659H14.6268C13.748 10.9659 13.0352 10.2542 13.0352 9.37532V3.84798ZM14.5694 3.77514C14.5459 3.79576 14.5352 3.82123 14.5352 3.84798V9.37532C14.5352 9.42464 14.5753 9.46595 14.6268 9.46595H20.1531C20.2118 9.46595 20.2573 9.41208 20.2501 9.35678C19.867 6.44316 17.5578 4.13397 14.6441 3.75099C14.6185 3.74763 14.5927 3.75464 14.5694 3.77514Z",
		fill: "#D9AA04"
	})]
});
export default SvgStatistic;
